import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { CreditNoteType, InvoiceCreditNoteType } from 'entities/CreditNote';
import { CreditNotesListFilterKeys } from '../../model/types';
import { MultipleSelect } from 'shared/ui/MultipleSelect';

interface CreditNoteTypeSelectProps {
  values: string[];
  onChange: (value: string[]) => void;
  onClear: (filterKey: string) => void;
}

export const CreditNoteTypeSelect: FC<CreditNoteTypeSelectProps> = memo((props) => {
  const { values, onChange, onClear } = props;

  const { t } = useAppTranslation(['contracts', 'common']);

  const creditNotesTypeOptions = useMemo<Array<{ label: string; value: CreditNoteType }>>(() => {
    return [
      { label: t(InvoiceCreditNoteType.DEBT_CREDIT, { ns: 'common' }), value: InvoiceCreditNoteType.DEBT_CREDIT },
      { label: t(InvoiceCreditNoteType.SERVICE_CREDIT, { ns: 'common' }), value: InvoiceCreditNoteType.SERVICE_CREDIT },
      { label: t(InvoiceCreditNoteType.IMPAIRMENT_DEBT_CREDIT, { ns: 'common' }), value: InvoiceCreditNoteType.IMPAIRMENT_DEBT_CREDIT },
    ];
  }, [t]);

  const clearFilter = useCallback(() => {
    onClear(CreditNotesListFilterKeys.creditNoteType);
  }, [onClear]);

  const handleChange = useCallback(
    (value: string[]): void => {
      value.length ? onChange(value) : clearFilter();
    },
    [onChange, clearFilter],
  );

  return (
    <MultipleSelect
      containerClassName="flex-1"
      className="w-full"
      label={t('Credit note type')}
      placeholder={t('All')}
      bordered
      allowClear
      options={creditNotesTypeOptions}
      value={values}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
